import React, { FC } from 'react';
import { ReactComponent as WarningSmallLightIcon } from '../../../../assets/images/warningSmall/WarningSmallLight.svg';
import { ReactComponent as WarningSmallDarkIcon } from '../../../../assets/images/warningSmall/WarningSmallDark.svg';
import { useAppSelector } from '../../../../hooks/redux';

interface WarningSmallIconProps {
  className?: string;
}

const defaultProps = {
  className: '',
};

export const WarningSmallIcon: FC<WarningSmallIconProps> = ({ className }) => {
  const { theme } = useAppSelector((state) => state.appReducer);

  const getIcon = (colorTheme: string) => {
    switch (true) {
      case colorTheme === 'light': {
        return <WarningSmallLightIcon className={className} />;
      }
      case colorTheme === 'dark': {
        return <WarningSmallDarkIcon className={className} />;
      }
      default: {
        return <WarningSmallLightIcon className={className} />;
      }
    }
  };
  return getIcon(theme);
};

WarningSmallIcon.defaultProps = defaultProps;
